<template>
    <Header></Header>
    <div class="container sub_page _activity">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민참여 활동</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li v-if="user.isLogin()" @click="changeTab(4)" :class="[state.tab === 4 ? 'active' : '']" class="w_1024_custom_width">
                        <a href="javascript:void(0)">액션 시민 활동</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!-- 
                <span class="icon_wrap"><img src="img/part_icon.png" alt="시민참여 활동" /></span>
                <a href="">시민참여 활동</a>
                 -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="반성매매 시민활동" /></span>
                <router-link :to="{ path: '/board', query: { type: 2 } }">캠페인·이벤트</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.data.title" /></span>
                <a href="javascript:void(0)" style="cursor: default">{{ state.data.title }}</a>
            </div>
            <div class="sub_page_con_view con_view">
                <div class="tit_wrap flex_wrap">
                    <span class="con_tit">{{ state.data.title }}</span>

                    <div class="con_tit_info event">
                        <span>
                            <span class="">{{ CommonUtils.dateFormat(new Date(state.data.createDate), ".", true) }}</span>
                            <span class="tit_info_item">
                                <img src="img/view.png" alt="" />
                                {{ state.data.viewCnt }}
                            </span>
                        </span>
                        <span class="writer_info">
                            <span>작성자</span>
                            {{ state.data.writer }}
                        </span>
                    </div>
                </div>
                <div class="con_info_wrap">
                    <div v-if="state.data.applyDate">
                        <span class="info_tit">
                            <img src="img/info_icon_02.png" alt="신청 마감" />
                            신청 마감
                        </span>
                        <span class="info_desc">
                            {{ CommonUtils.dateFormat(new Date(state.data.applyDate), ".", false) }}
                        </span>
                    </div>
                    <div v-if="state.data.cntApply > 0">
                        <span class="info_tit">
                            <img src="img/info_icon_03.png" alt="모집인원" />
                            모집인원
                        </span>
                        <span class="info_desc">{{ state.data.cntApply ? CommonUtils.numberFormat(state.data.cntApply) : "" }}명</span>
                    </div>
                </div>
                <div class="">
                    <div class="content" v-html="CommonUtils.decodeContent(state.data.content)"></div>
                    <div class="file_list_wrap _column" v-if="state.data.fileList != null && state.data.fileList.length > 0">
                        <div v-for="item in state.data.fileList" :key="item.idx">
                            <button type="button" @click="downloadFile(item.file, item.imgRealName)">
                                <span class="file_name">{{ item.imgRealName }}</span>
                                <img src="img/download.png" alt="" />
                            </button>
                        </div>
                    </div>
                    <div class="apply_wrap btn_wrap _default _center" v-if="!state.hasAuth">
                        <template v-if="state.data.state === 2">
                            <button class="common_btn w_130" v-if="state.data.idx === state.eventIdx" @click="participate">참여하기</button>
                            <button class="common_btn w_130" v-else @click="apply">신청하기</button>
                        </template>
                        <button class="common_btn _gray w_130" @click="router.push('/board?type=2')">목록</button>
                    </div>
                </div>
                <!--관리자 버튼-->
                <div class="apply_wrap btn_wrap _default right_btn" v-if="state.hasAuth">
                    <button class="common_btn _gray" type="button" @click="confirmRemove">삭제</button>
                    <button class="common_btn" type="button" @click="router.push({ name: 'EventModify', params: { id: state.idx } })">수정</button>

                    <button
                        class="common_btn"
                        type="button"
                        @click="showModalForApply"
                        v-if="!state.isMobile && new Date(state.data.recruitStartDate) < new Date()"
                    >
                        신청인원
                    </button>

                    <button class="common_btn" type="button" @click="router.push('/board?type=2')">목록</button>
                </div>
                <!--관리자 버튼-->
            </div>
            <div class="list_wrap">
                <router-link v-if="state.data.next" :to="{ name: 'EventView', params: { id: state.data.next.idx } }" class="next_list">
                    <span>다음글</span>
                    <div class="list_tit elips_1">
                        {{ state.data.next.title }}
                    </div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.next.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.next.createDate), ".", true) }}</div>
                </router-link>

                <router-link v-if="state.data.prev" :to="{ name: 'EventView', params: { id: state.data.prev.idx } }" class="prev_list">
                    <span>이전글</span>
                    <div class="list_tit elips_1">{{ state.data.prev.title }}</div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.prev.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.prev.createDate), ".", true) }}</div>
                </router-link>
            </div>
        </section>
    </div>

    <ModalApplicantCheckForCampaign
        v-if="state.isShowModalForApply"
        :idx="state.idx"
        :data="state.data"
        @close="state.isShowModalForApply = false"
        @save="saveMemo"
    ></ModalApplicantCheckForCampaign>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :isPossible="true"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <EventModal
        v-if="state.isShowModalEvent"
        title="<액션시민> 반성매매 온라인 캠페인"
        @close="closeEventModal"
        @callback="callBackModal"
    ></EventModal>

    <PaperModal v-if="state.isShowModalApply" :list="state.listForm" @close="state.isShowModalApply = false" @save="answerSave"></PaperModal>
    <IframeModal v-if="state.isShowIframe" :url="state.modalContent" @close="closeIframe"></IframeModal>
    <ModalTermsForBoard
        v-if="state.isShowTerm && state.data.term"
        :content="CommonUtils.decodeContent(state.data.term)"
        @close="closeTerm"
    ></ModalTermsForBoard>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        Header,
        Footer,
        types,
        apiService,
        useRoute,
        userStore,
        CommonUtils,
        ModalDefault,
        onBeforeMount,
        getMessageByCode,
        ModalApplicantCheckForCampaign,
        ModalEventApply,
        EventModal,
        PaperModal,
        IframeModal,
        ModalTermsForBoard,
    } from "@/BaseComponent";

    export default {
        components: {
            Header,
            Footer,
            ModalDefault,
            ModalApplicantCheckForCampaign,
            ModalEventApply,
            EventModal,
            PaperModal,
            IframeModal,
            ModalTermsForBoard,
        },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 2 as number,
                idx: 0 as number,
                eventIdx: 139 as number | null,

                data: {} as types.ResBoardVOForApi,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false as boolean,

                isShowModalForApply: false as boolean,
                isShowModalApply: false as boolean,
                isShowModalEvent: false as boolean,
                isShowIframe: false as boolean,
                isShowTerm: false as boolean,

                subMenuOpen: false,
                subMenuName: "캠페인·이벤트" as string,

                isMobile: false,

                listForm: [] as Array<types.BoardApplyFormVOForApi>,
                answerData: [] as Array<types.ReqBoardApplyFormAnswer>,
            });

            const form_state = reactive({
                name: "" as string,
                phoneNum: "" as string,
                email: "" as string,
                isAgree: 0 as number,
                age: 0 as number,
                review: "" as string,
                step1: "" as string,
                step2: "" as string,
                step3: "" as string,
                myComment: "" as string,
            });

            const config = reactive({
                visible: false,
                width: 600,
                height: 400,
                penColor: "black",
                backgroundColor: "white",
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                const idx = Number(route.params.id);

                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;
                    getDetail();
                } else {
                    router.back();
                }

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            watch(
                () => [user.userInfo, user.accessToken],
                () => {
                    hasAuth();
                    getDetail();
                },
            );

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("area") > -1)))
                )
                    state.hasAuth = true;
            };

            const changeTab = (tab: number) => {
                global.setBoardTab(tab);
                router.push("/board?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const getDetail = async () => {
                const res = await apiService.boardEvent.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeSignModal = () => {
                config.visible = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 8) router.back();
            };

            const closeEventModal = () => {
                state.isShowModalEvent = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    removeData();
                } else if (param.action === "callback") {
                    if (state.data.idx === state.eventIdx) {
                        // 7월 이벤트 라우터 이동
                        router.push("/activityView/136");
                    } else if (state.data.urlCallback) {
                        state.isShowModal = false;
                        location.href = state.data.urlCallback;
                    } else {
                        state.isShowModal = false;
                        router.replace({ path: "/login", query: { redirect: "/eventView/" + state.idx } });
                    }
                } else if (param.action === "back") {
                    state.isShowModal = false;
                    router.back();
                } else if (param.action === "applyContent") {
                    form_state.name = param.name;
                    form_state.phoneNum = param.phoneNum;
                    form_state.email = param.email;
                    form_state.isAgree = param.isAgree;
                    form_state.age = param.age;
                    form_state.review = param.review;
                    if (state.data.idx === state.eventIdx) {
                        await applyInsertForCampainEvent();
                    } else {
                        await applyInsert();
                    }
                } else if (param.action === "eventComplete") {
                    state.isShowModalEvent = false;
                    form_state.step1 = param.eventData.step1.join(",");
                    form_state.step2 = param.eventData.step2.join(",");
                    form_state.step3 = param.eventData.step3.join(",");
                    form_state.myComment = param.eventData.myComment;
                    apply();
                }
            };

            const apply = () => {
                if (state.data.urlForEvent) {
                    isShowIframe(state.data.urlForEvent);

                    window.addEventListener("message", (event) => {
                        const origin = new URL(state.data.urlForEvent).origin;

                        if (event.origin !== origin) {
                            return;
                        }

                        if (event.data?.type === "BUTTON_CLICK") {
                            closeIframe();
                        }
                    });
                } else getFormList();
            };

            const isShowIframe = (url: string) => {
                state.isShowIframe = true;
                state.modalContent = url;
            };

            const closeIframe = () => {
                state.isShowIframe = false;
                getFormList();
            };

            const getFormList = async () => {
                state.listForm = [];
                state.answerData = [];
                const res = await apiService.boardEvent.formList(state.idx);
                if (res.returnCode === 0) {
                    state.listForm = res.data;
                    state.isShowModalApply = true;
                } else if (res.returnCode === 29) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "신청 양식이 준비되지 않았습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const participate = () => {
                state.isShowModalEvent = true;
            };

            const applyInsert = async () => {
                const param: types.ReqBoardApplyForModify = {
                    interest: null,
                    apply: null,
                    answers: state.answerData,
                };

                const res = await apiService.boardEvent.apply(state.idx, param);
                if (res.returnCode === 0) {
                    state.isShowModalApply = false;
                    state.modalTab = state.data.urlCallback ? 7 : -1;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = "신청이 완료되었습니다.";
                    getDetail();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const applyInsertForCampainEvent = async () => {
                const param: types.ReqBoardApplyForEvent = {
                    name: form_state.name,
                    phoneNum: form_state.phoneNum,
                    email: form_state.email,
                    isAgree: form_state.isAgree,
                    age: form_state.age,
                    ...(form_state.review ? { review: form_state.review } : {}),
                    step1: form_state.step1,
                    step2: form_state.step2,
                    step3: form_state.step3,
                    myComment: form_state.myComment,
                };

                const res = await apiService.campainEvent.apply(state.idx, param);
                if (res.returnCode === 0) {
                    state.isShowModalApply = false;
                    state.modalTab = 7;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = "신청이 완료되었습니다.";
                    getDetail();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            // // 저장 이벤트 수신
            const answerSave = async (answer: types.ReqBoardApplyFormAnswer[]) => {
                state.answerData = answer;
                state.isShowModalApply = false;
                if (state.data.term) state.isShowTerm = true;
                else applyInsert();
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const removeData = async () => {
                const res = await apiService.boardEvent.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = "삭제가 완료되었습니다.";
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmRemove = () => {
                if (user.isLogin()) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            const showModalForApply = () => {
                state.isShowModalForApply = true;
            };

            const saveMemo = async (memo: string) => {
                const param: types.ReqBoardForEventForModify = {
                    title: null,
                    content: null,
                    term: null,
                    activityStartDate: null,
                    activityEndDate: null,
                    recruitmentStartDate: null,
                    recruitmentEndDate: null,
                    endDate: null,
                    cntMember: null,
                    zipCode: null,
                    address: null,
                    addressDetail: null,
                    file: null,
                    cntWin: state.data.cntWin,
                    memo: state.data.memo,
                    urlCallback: null,
                    urlForEvent: null,
                };

                const res = await apiService.boardEvent.modify(state.idx, param);

                if (res.returnCode === 0) {
                    getDetail();
                    state.isShowModalForApply = false;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeTerm = (result: boolean) => {
                state.isShowTerm = false;
                if (result) applyInsert();
            };

            return {
                state,
                router,
                user,
                changeTab,
                subMenuTab,
                CommonUtils,
                form_state,
                apply,
                closeModal,
                applyInsert,
                closeSignModal,
                callBackModal,
                config,
                confirmRemove,
                saveMemo,
                showModalForApply,
                downloadFile,
                closeEventModal,
                participate,
                answerSave,
                closeIframe,
                closeTerm,
            };
        },
    };
</script>

<style scoped>
    .tit_wrap img {
        vertical-align: unset;
    }
    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }

    .bread_crumbs a {
        white-space: wrap;
    }
</style>
<style>
    .sub_page_con .content p {
        word-break: break-word;
    }
</style>
